/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ControlBlock_SetCoordinatesMode } from '../models/BigClock_Api_Models_ControlBlock_SetCoordinatesMode';
import type { BigClock_Api_Models_ControlBlock_SetEthernetSettingsModel } from '../models/BigClock_Api_Models_ControlBlock_SetEthernetSettingsModel';
import type { BigClock_Api_Models_ControlBlock_SetSimContextModel } from '../models/BigClock_Api_Models_ControlBlock_SetSimContextModel';
import type { BigClock_Api_Models_ControlBlock_SetSunSetRaiseCorrectionMode } from '../models/BigClock_Api_Models_ControlBlock_SetSunSetRaiseCorrectionMode';
import type { BigClock_Api_Models_ControlBlock_UpdateArticleModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateArticleModel';
import type { BigClock_Api_Models_ControlBlock_UpdateClockSystemSerialNumberModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateClockSystemSerialNumberModel';
import type { BigClock_Api_Models_ControlBlock_UpdateControlBlockMaintenanceModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateControlBlockMaintenanceModel';
import type { BigClock_Api_Models_ControlBlock_UpdateControlBlockWarrantyModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateControlBlockWarrantyModel';
import type { BigClock_Api_Models_ControlBlock_UpdateModelModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateModelModel';
import type { BigClock_Api_Models_ControlBlock_UpdateSerialNumberModel } from '../models/BigClock_Api_Models_ControlBlock_UpdateSerialNumberModel';
import type { BigClock_Api_Models_ControlBlock_UsbModemLocationModel } from '../models/BigClock_Api_Models_ControlBlock_UsbModemLocationModel';
import type { BigClock_Api_Models_ControlBlock_WifiEthernetSettingsModel } from '../models/BigClock_Api_Models_ControlBlock_WifiEthernetSettingsModel';
import type { BigClock_Api_Models_ControlBlockIdsDto } from '../models/BigClock_Api_Models_ControlBlockIdsDto';
import type { BigClock_Api_Models_DevicesClockSyncSourceModel } from '../models/BigClock_Api_Models_DevicesClockSyncSourceModel';
import type { BigClock_Api_Models_EthernetSettingsModel } from '../models/BigClock_Api_Models_EthernetSettingsModel';
import type { BigClock_Api_Models_SetDeviceSourceModel } from '../models/BigClock_Api_Models_SetDeviceSourceModel';
import type { BigClock_Api_Models_SetEspTimeSyncSourceModel } from '../models/BigClock_Api_Models_SetEspTimeSyncSourceModel';
import type { BigClock_Api_Models_StandardTimeModel } from '../models/BigClock_Api_Models_StandardTimeModel';
import type { BigClock_Api_Models_StandardTimeOffsetModel } from '../models/BigClock_Api_Models_StandardTimeOffsetModel';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Api_Models_UpdateDescriptionModel } from '../models/BigClock_Api_Models_UpdateDescriptionModel';
import type { BigClock_Api_Models_UpdateFirmwareFromLinkModel } from '../models/BigClock_Api_Models_UpdateFirmwareFromLinkModel';
import type { BigClock_Api_Models_UpdatePrivateDescriptionModel } from '../models/BigClock_Api_Models_UpdatePrivateDescriptionModel';
import type { BigClock_Api_Models_Usb_UsbResetPowerModel } from '../models/BigClock_Api_Models_Usb_UsbResetPowerModel';
import type { BigClock_Api_Models_Usb_UsbSchedulerModeModel } from '../models/BigClock_Api_Models_Usb_UsbSchedulerModeModel';
import type { BigClock_Api_Models_Usb_UsbSettingsModel } from '../models/BigClock_Api_Models_Usb_UsbSettingsModel';
import type { BigClock_Api_Models_Usb_UsbTimeModel } from '../models/BigClock_Api_Models_Usb_UsbTimeModel';
import type { BigClock_Application_Commands_DeleteLinkUserAndDevice_LinkUserAndDeviceCommand } from '../models/BigClock_Application_Commands_DeleteLinkUserAndDevice_LinkUserAndDeviceCommand';
import type { BigClock_Application_Commands_LinkUserAndDevice_DeleteLinkUserAndDeviceCommand } from '../models/BigClock_Application_Commands_LinkUserAndDevice_DeleteLinkUserAndDeviceCommand';
import type { BigClock_Application_Queries_Common_ControlBlockDto } from '../models/BigClock_Application_Queries_Common_ControlBlockDto';
import type { BigClock_Application_Queries_GetConnectedDevices_GetConnectedDevicesResponse } from '../models/BigClock_Application_Queries_GetConnectedDevices_GetConnectedDevicesResponse';
import type { BigClock_Application_Queries_GetControlBlockDateTime_GetControlBlockDateTimeResponse } from '../models/BigClock_Application_Queries_GetControlBlockDateTime_GetControlBlockDateTimeResponse';
import type { BigClock_Application_Queries_GetControlBlockNtpDateTime_GetControlBlockNtpDateTimeResponse } from '../models/BigClock_Application_Queries_GetControlBlockNtpDateTime_GetControlBlockNtpDateTimeResponse';
import type { BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse } from '../models/BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse';
import type { BigClock_Application_Queries_GetDevices_GetDevicesResponse } from '../models/BigClock_Application_Queries_GetDevices_GetDevicesResponse';
import type { BigClock_Application_Queries_GetEspAutoUpdateState_GetEspAutoUpdateStateResponse } from '../models/BigClock_Application_Queries_GetEspAutoUpdateState_GetEspAutoUpdateStateResponse';
import type { BigClock_Application_Queries_GetEspBluetoothState_GetEspBluetoothStateResponse } from '../models/BigClock_Application_Queries_GetEspBluetoothState_GetEspBluetoothStateResponse';
import type { BigClock_Application_Queries_GetEspConnections_GetEspConnectionsResponse } from '../models/BigClock_Application_Queries_GetEspConnections_GetEspConnectionsResponse';
import type { BigClock_Application_Queries_GetEspSystemData_GetEspSystemDataResponse } from '../models/BigClock_Application_Queries_GetEspSystemData_GetEspSystemDataResponse';
import type { BigClock_Application_Queries_GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse } from '../models/BigClock_Application_Queries_GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse';
import type { BigClock_Application_Queries_GetSimData_GetSimDataResponse } from '../models/BigClock_Application_Queries_GetSimData_GetSimDataResponse';
import type { BigClock_Application_Queries_GetWiFiNetworks_GetWiFiNetworksResponse } from '../models/BigClock_Application_Queries_GetWiFiNetworks_GetWiFiNetworksResponse';
import type { BigClock_Application_Queries_GetWiFiState_GetWiFiStateResponse } from '../models/BigClock_Application_Queries_GetWiFiState_GetWiFiStateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControlBlocksService {
    /**
     * @returns BigClock_Application_Queries_Common_ControlBlockDto Success
     * @throws ApiError
     */
    public static getApiControlBlocks(): CancelablePromise<Array<BigClock_Application_Queries_Common_ControlBlockDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_Common_ControlBlockDto Success
     * @throws ApiError
     */
    public static getApiControlBlocks1(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_Common_ControlBlockDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteApiControlBlocks(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ControlBlocks/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksModel(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateModelModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/model',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksArticle(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateArticleModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/article',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksSerialNumber(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateSerialNumberModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/serial-number',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksClockSystemSerialNumber(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateClockSystemSerialNumberModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/clock-system-serial-number',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksWarranty(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateControlBlockWarrantyModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/warranty',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksMaintenance(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UpdateControlBlockMaintenanceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/maintenance',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksUsbPowerReset(
        id: string,
        requestBody?: BigClock_Api_Models_Usb_UsbResetPowerModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/usb/power/reset',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksUsbDisableTime(
        id: string,
        requestBody?: BigClock_Api_Models_Usb_UsbTimeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/usb/disable-time',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksUsbEnableTime(
        id: string,
        requestBody?: BigClock_Api_Models_Usb_UsbTimeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/usb/enable-time',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksUsbSchedulerMode(
        id: string,
        requestBody?: BigClock_Api_Models_Usb_UsbSchedulerModeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/usb/scheduler/mode',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Api_Models_Usb_UsbSettingsModel Success
     * @throws ApiError
     */
    public static getApiControlBlocksUsbSettings(
        id: string,
    ): CancelablePromise<BigClock_Api_Models_Usb_UsbSettingsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/usb/settings',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetControlBlockDateTime_GetControlBlockDateTimeResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksTime(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetControlBlockDateTime_GetControlBlockDateTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/time',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetControlBlockNtpDateTime_GetControlBlockNtpDateTimeResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksTimeNtp(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetControlBlockNtpDateTime_GetControlBlockNtpDateTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/time/ntp',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetEspSystemData_GetEspSystemDataResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksSystemData(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetEspSystemData_GetEspSystemDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/system-data',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksTimeUtc(
        id: string,
        requestBody?: BigClock_Api_Models_StandardTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/time/utc',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksTimeTimezone(
        id: string,
        requestBody?: BigClock_Api_Models_StandardTimeOffsetModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/time/timezone',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksTimeSynchronize(
        id: string,
        requestBody?: BigClock_Api_Models_SetEspTimeSyncSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/time/synchronize',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksDescription(
        id: string,
        requestBody?: BigClock_Api_Models_UpdateDescriptionModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/description',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiControlBlocksDescriptionPrivate(
        id: string,
        requestBody?: BigClock_Api_Models_UpdatePrivateDescriptionModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ControlBlocks/{id}/description/private',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksStatus(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/status',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse Success
     * @throws ApiError
     */
    public static postApiControlBlocksStatusBatch(
        requestBody?: BigClock_Api_Models_ControlBlockIdsDto,
    ): CancelablePromise<Array<BigClock_Application_Queries_GetControlBlockStatusBatch_GetControlBlockStatusBatchResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/status/batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param formData
     * @returns string Success
     * @throws ApiError
     */
    public static postApiControlBlocksPreview(
        id: string,
        formData?: {
            photo?: Blob;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/preview',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetDevices_GetDevicesResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksDevices(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDevices_GetDevicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/devices',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetConnectedDevices_GetConnectedDevicesResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksDevicesConnected(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetConnectedDevices_GetConnectedDevicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/devices/connected',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Api_Models_DevicesClockSyncSourceModel Success
     * @throws ApiError
     */
    public static getApiControlBlocksDevicesTimeSynchronizationSource(
        id: string,
    ): CancelablePromise<BigClock_Api_Models_DevicesClockSyncSourceModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/devices/time/synchronization/source',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksDevicesTimeSynchronizationSource(
        id: string,
        requestBody?: BigClock_Api_Models_DevicesClockSyncSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/devices/time/synchronization/source',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @deprecated
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksDevicesTimeSyncSource(
        id: string,
        requestBody?: BigClock_Api_Models_DevicesClockSyncSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/devices/time/sync/source',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksDevicesTimeSyncNow(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/devices/time/sync/now',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @deprecated
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static getApiControlBlocksFirmwareUpdateAuto(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/firmware/update/auto',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksFirmwareUpdateAuto(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/firmware/update/auto',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetEspAutoUpdateState_GetEspAutoUpdateStateResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksFirmwareState(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetEspAutoUpdateState_GetEspAutoUpdateStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/firmware/state',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksFirmwareRelease(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/firmware/release',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksFirmwareUpdateFromLink(
        id: string,
        requestBody?: BigClock_Api_Models_UpdateFirmwareFromLinkModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/firmware/update/from-link',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksFirmwareUpload(
        id: string,
        formData?: {
            file: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/firmware/upload',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetEspConnections_GetEspConnectionsResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksConnections(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetEspConnections_GetEspConnectionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/connections',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksConnectionsModemLocation(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_UsbModemLocationModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/connections/modem/location',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Api_Models_EthernetSettingsModel Success
     * @throws ApiError
     */
    public static getApiControlBlocksEthernetLink(
        id: string,
    ): CancelablePromise<BigClock_Api_Models_EthernetSettingsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/ethernet/link',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksEthernetLink(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_SetEthernetSettingsModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/ethernet/link',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Api_Models_ControlBlock_WifiEthernetSettingsModel Success
     * @throws ApiError
     */
    public static getApiControlBlocksEthernetWifi(
        id: string,
    ): CancelablePromise<BigClock_Api_Models_ControlBlock_WifiEthernetSettingsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/ethernet/wifi',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksEthernetWifi(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_WifiEthernetSettingsModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/ethernet/wifi',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetWiFiState_GetWiFiStateResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksEthernetWifiState(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetWiFiState_GetWiFiStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/ethernet/wifi/state',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetWiFiNetworks_GetWiFiNetworksResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksEthernetWifiNetworks(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetWiFiNetworks_GetWiFiNetworksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/ethernet/wifi/networks',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetEspBluetoothState_GetEspBluetoothStateResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksBluetoothState(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetEspBluetoothState_GetEspBluetoothStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/bluetooth/state',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksBluetoothState(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/bluetooth/state',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiControlBlocksLink(
        requestBody?: BigClock_Application_Commands_DeleteLinkUserAndDevice_LinkUserAndDeviceCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/link',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiControlBlocksLink(
        requestBody?: BigClock_Application_Commands_LinkUserAndDevice_DeleteLinkUserAndDeviceCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ControlBlocks/link',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksCorrectionSunset(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_SetSunSetRaiseCorrectionMode,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/correction/sunset',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksCorrectionSunraise(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_SetSunSetRaiseCorrectionMode,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/correction/sunraise',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksCoordinates(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_SetCoordinatesMode,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/coordinates',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksBlank(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/blank',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetSimData_GetSimDataResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksSim(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetSimData_GetSimDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/sim',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksSim(
        id: string,
        requestBody?: BigClock_Api_Models_ControlBlock_SetSimContextModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/sim',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksSimRestart(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/sim/restart',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksDebugOutput(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/debug-output',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksReboot(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/reboot',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksLedState(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/led/state',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns BigClock_Application_Queries_GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse Success
     * @throws ApiError
     */
    public static getApiControlBlocksMeteoSource(
        id: string,
    ): CancelablePromise<BigClock_Application_Queries_GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ControlBlocks/{id}/meteo-source',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksMeteoSource(
        id: string,
        requestBody?: BigClock_Api_Models_SetDeviceSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/meteo-source',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksGpsGpsSource(
        id: string,
        requestBody?: BigClock_Api_Models_SetDeviceSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/gps/gps-source',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksGpsUseCoords(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/gps/use-coords',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiControlBlocksGpsUseTime(
        id: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ControlBlocks/{id}/gps/use-time',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
